
import React from "react";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

interface FormButtonProps {
  loading: boolean;
  success: boolean;
  disabled?: boolean;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
}

const FormButton: React.FC<FormButtonProps> = ({ 
  loading, 
  success, 
  disabled = false, 
  onClick,
  type = "button"
}) => {
  return (
    <Button 
      type={type}
      className="w-full"
      disabled={loading || success || disabled}
      onClick={onClick}
    >
      {loading ? (
        <span className="flex items-center gap-2">
          <span className="animate-spin h-4 w-4 border-2 border-current border-t-transparent rounded-full" />
          Creating Agent...
        </span>
      ) : success ? (
        <span className="flex items-center gap-2">
          <Check className="h-4 w-4" />
          Agent Created!
        </span>
      ) : (
        "Create Agent"
      )}
    </Button>
  );
};

export default FormButton;
